// Get All HDFC Card UP Constants
export const GET_ALL_HDFC_CARD_UP_REQUEST = "GET_ALL_HDFC_CARD_UP_REQUEST";
export const GET_ALL_HDFC_CARD_UP_SUCCESS = "GET_ALL_HDFC_CARD_UP_SUCCESS";
export const GET_ALL_HDFC_CARD_UP_FAIL = "GET_ALL_HDFC_CARD_UP_FAIL";
export const GET_ALL_HDFC_CARD_UP_RESET = "GET_ALL_HDFC_CARD_UP_RESET";

// Create HDFC Card UP Constants
export const CREATE_HDFC_CARD_UP_REQUEST = "CREATE_HDFC_CARD_UP_REQUEST";
export const CREATE_HDFC_CARD_UP_SUCCESS = "CREATE_HDFC_CARD_UP_SUCCESS";
export const CREATE_HDFC_CARD_UP_FAIL = "CREATE_HDFC_CARD_UP_FAIL";
export const CREATE_HDFC_CARD_UP_RESET = "CREATE_HDFC_CARD_UP_RESET";

// Update HDFC Card UP Constants
export const UPDATE_HDFC_CARD_UP_REQUEST = "UPDATE_HDFC_CARD_UP_REQUEST";
export const UPDATE_HDFC_CARD_UP_SUCCESS = "UPDATE_HDFC_CARD_UP_SUCCESS";
export const UPDATE_HDFC_CARD_UP_FAIL = "UPDATE_HDFC_CARD_UP_FAIL";
export const UPDATE_HDFC_CARD_UP_RESET = "UPDATE_HDFC_CARD_UP_RESET";

// Delete HDFC Card UP Constants
export const DELETE_HDFC_CARD_UP_REQUEST = "DELETE_HDFC_CARD_UP_REQUEST";
export const DELETE_HDFC_CARD_UP_SUCCESS = "DELETE_HDFC_CARD_UP_SUCCESS";
export const DELETE_HDFC_CARD_UP_FAIL = "DELETE_HDFC_CARD_UP_FAIL";
export const DELETE_HDFC_CARD_UP_RESET = "DELETE_HDFC_CARD_UP_RESET";

// Bulk Delete HDFC Card UP Constants
export const BULK_DELETE_HDFC_CARD_UP_REQUEST =
  "BULK_DELETE_HDFC_CARD_UP_REQUEST";
export const BULK_DELETE_HDFC_CARD_UP_SUCCESS =
  "BULK_DELETE_HDFC_CARD_UP_SUCCESS";
export const BULK_DELETE_HDFC_CARD_UP_FAIL = "BULK_DELETE_HDFC_CARD_UP_FAIL";
export const BULK_DELETE_HDFC_CARD_UP_RESET = "BULK_DELETE_HDFC_CARD_UP_RESET";

// Import HDFC Card UP Constants
export const IMPORT_HDFC_CARD_UP_REQUEST = "IMPORT_HDFC_CARD_UP_REQUEST";
export const IMPORT_HDFC_CARD_UP_SUCCESS = "IMPORT_HDFC_CARD_UP_SUCCESS";
export const IMPORT_HDFC_CARD_UP_FAIL = "IMPORT_HDFC_CARD_UP_FAIL";
export const IMPORT_HDFC_CARD_UP_RESET = "IMPORT_HDFC_CARD_UP_RESET";

// Export HDFC Card UP Constants
export const EXPORT_HDFC_CARD_UP_REQUEST = "EXPORT_HDFC_CARD_UP_REQUEST";
export const EXPORT_HDFC_CARD_UP_SUCCESS = "EXPORT_HDFC_CARD_UP_SUCCESS";
export const EXPORT_HDFC_CARD_UP_FAIL = "EXPORT_HDFC_CARD_UP_FAIL";
export const EXPORT_HDFC_CARD_UP_RESET = "EXPORT_HDFC_CARD_UP_RESET";

// Sync HDFC Card UP Task Status Constants
export const SYNC_HDFC_CARD_UP_TASK_STATUS_REQUEST =
  "SYNC_HDFC_CARD_UP_TASK_STATUS_REQUEST";
export const SYNC_HDFC_CARD_UP_TASK_STATUS_SUCCESS =
  "SYNC_HDFC_CARD_UP_TASK_STATUS_SUCCESS";
export const SYNC_HDFC_CARD_UP_TASK_STATUS_FAIL =
  "SYNC_HDFC_CARD_UP_TASK_STATUS_FAIL";
export const SYNC_HDFC_CARD_UP_TASK_STATUS_RESET =
  "SYNC_HDFC_CARD_UP_TASK_STATUS_RESET";

// Get HDFC Card UP Departments Constants
export const GET_HDFC_CARD_UP_DEPARTMENTS_REQUEST =
  "GET_HDFC_CARD_UP_DEPARTMENTS_REQUEST";
export const GET_HDFC_CARD_UP_DEPARTMENTS_SUCCESS =
  "GET_HDFC_CARD_UP_DEPARTMENTS_SUCCESS";
export const GET_HDFC_CARD_UP_DEPARTMENTS_FAIL =
  "GET_HDFC_CARD_UP_DEPARTMENTS_FAIL";
export const GET_HDFC_CARD_UP_DEPARTMENTS_RESET =
  "GET_HDFC_CARD_UP_DEPARTMENTS_RESET";
